var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipsis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 4,
    viewBox: "0 0 19 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00195 4C3.10652 4 4.00195 3.10457 4.00195 2C4.00195 0.89543 3.10652 0 2.00195 0C0.897384 0 0.00195312 0.89543 0.00195312 2C0.00195312 3.10457 0.897384 4 2.00195 4Z",
    fill: "#42526E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00195 4C10.1065 4 11.002 3.10457 11.002 2C11.002 0.89543 10.1065 0 9.00195 0C7.89738 0 7.00195 0.89543 7.00195 2C7.00195 3.10457 7.89738 4 9.00195 4Z",
    fill: "#42526E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.002 4C17.1065 4 18.002 3.10457 18.002 2C18.002 0.89543 17.1065 0 16.002 0C14.8974 0 14.002 0.89543 14.002 2C14.002 3.10457 14.8974 4 16.002 4Z",
    fill: "#42526E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.bf9544639a6faa27cfeeefb26acd661c.svg";
export { ForwardRef as ReactComponent };